import { render, staticRenderFns } from "./TiposAtividade.vue?vue&type=template&id=2ad74a9a&"
import script from "./TiposAtividade.vue?vue&type=script&lang=js&"
export * from "./TiposAtividade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports